import {
  DEFAULT_REGISTER_RECENCY_STRATUM,
  REGISTER_RECENCY_STRATA,
  sanitizeRegisterRecencyStratum,
} from "../constants/registerRecencyStrata";
import "./RegisterRecencyStrataSwitch.css";

export default function RegisterRecencyStrataSwitch({
  value = DEFAULT_REGISTER_RECENCY_STRATUM,
  onChange = () => {},
  strata = REGISTER_RECENCY_STRATA,
  ariaLabel = "Strates de récence des mots",
}) {
  const ids = strata.map((stratum) => stratum.id);
  const activeId = ids.includes(value)
    ? value
    : sanitizeRegisterRecencyStratum(value);

  return (
    <div
      className="register-recency-switch"
      role="radiogroup"
      aria-label={ariaLabel}
    >
      {strata.map((stratum) => {
        const isActive = stratum.id === activeId;
        return (
          <button
            key={stratum.id}
            type="button"
            role="radio"
            aria-checked={isActive}
            aria-label={`${stratum.title}. ${stratum.subtitle}`}
            className={[
              "register-recency-switch__segment",
              `register-recency-switch__segment--${stratum.id}`,
              isActive && "is-active",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => {
              if (!isActive) onChange(stratum.id);
            }}
          >
            <span className="register-recency-switch__copy" aria-hidden={!isActive}>
              <span className="register-recency-switch__title">{stratum.title}</span>
              <span className="register-recency-switch__subtitle">{stratum.subtitle}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

